<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <div class="d-flex justify-content-between row">
                <h3 class="mb-0">System Users</h3>
                <div class="col-md-2">
                    <form>
                        <base-input>
                            <select class="form-control" v-model="status" required @change="handleChange">
                                <option value="all" selected>All</option>
                                <option value="active">Active</option>
                                <option value="archived">Archived</option>
                            </select>
                        </base-input>
                    </form>
                </div>
                <div class="col-md-4">
                    <base-search @applySearch="applySearch"></base-search>
                </div>
                <div class="col-md-4">
                    <base-button @click="$bvModal.show('add-system-user-popup')" btn-variant="primary"
                        :class="loading ? 'disabled' : ''" :loading="loading">+ Add User</base-button>
                </div>
            </div>
        </b-card-header>

        <el-table class="table-responsive table" header-row-class-name="thead-light"
            :row-class-name="disableLoggedInUser" :data="users">
            <el-table-column label="Name" min-width="110px" prop="firstName">
                <!-- Add a click event handler to the row -->
                <template v-slot="{ row }">
                    <a @click="navigateToUser(row._id)">
                        <b-media no-body class="align-items-center">
                            <b-media-body>
                                <span class="font-weight-600 name mb-0 text-sm">{{
                                row.firstName + " " + row.lastName
                            }}</span>
                            </b-media-body>
                        </b-media>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="Role" prop="role.title" min-width="140px">
            </el-table-column>
            <el-table-column label="Email" prop="email" min-width="140px">
            </el-table-column>

            <el-table-column label="Phone Number" min-width="170px" prop="phoneNumber">
                <template v-slot="{ row }">
                    <span>0{{ row.phoneNumber }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Username" prop="username" min-width="140px">
            </el-table-column>
            <el-table-column label="Status" prop="status" min-width="140px">
            </el-table-column>
            <el-table-column label="Action" prop="" min-width="140px">
                <template slot-scope="scope">
                    <base-action icon="ni ni-settings" label="Modify" @click="
                                selectedRecord(scope.row)
                            $bvModal.show('add-system-user-popup')
                                "></base-action>
                </template>
            </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="page" :per-page="10" :total="totalUsers"
                @change="handlePageChange"></base-pagination>
        </b-card-footer>

        <add-system-user-popup @child-event="handleSave"></add-system-user-popup>

    </b-card>
</template>

<script>
import request from "../../../util/request"
import { Table, TableColumn } from "element-ui";
import BaseSearch from "../../../components/BaseSearch.vue";
import BaseAction from '../../../components/BaseAction'
import AddSystemUserPopup from '../../../components/popups/AddSystemUserPopup'
import { mapGetters } from 'vuex'

export default {
    name: "light-table",
    components: {
        BaseSearch,
        BaseAction,
        AddSystemUserPopup,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            users: [],
            page: 1,
            limit: 10,
            totalUsers: 0,
            total: 0,
            keyword: "",
            status: "all",
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.limit);
        },
        ...mapGetters(['user']),
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method
        handleSave() {
            this.fetchData()
        },
        async fetchData() {
            this.$store.commit('setLoading', false);

            try {
                const { data, headers } = await request.get('/system-users/', {
                    params: {
                        page: this.page,
                        limit: this.limit,
                        keyword: this.keyword,
                        status: this.status,
                    },
                });

                this.users = data.users;
                console.log(data.count);
                this.totalUsers = data.count;
                this.total = headers["x-total-count"];
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        },
        handlePageChange(page) {
            this.page = page;
            this.fetchData();
        },
        navigateToUser(id) {
            // Use programmatic navigation to navigate to the user route with the ID
            this.$router.push({ name: "user", params: { id } });
        },
        applySearch(e) {
            this.keyword = e;
            this.fetchData();
        },
        handleChange() {
            this.fetchData();
        },
        disableLoggedInUser({ row, rowIndex }) {
            if (!row) return
            if (row.username === this.user.username) return 'disable-row'
        },
    },
};
</script>
<style>
.disable-row {
    pointer-events: none;
    background-color: lightgray !important;
}
</style>
